<template>
    <PopupShell
        :image="require(`@/assets/img/graphic_warning_yellow.svg`)"
        title="All Changes will be lost if you leave wihout saving."
    >
    <div>
        <GreyButton @click="$emit('cancel')">Cancel</GreyButton>

        <router-link to="active-listings">
            <BlackButton class="mv2">Leave Without Saving</BlackButton>
        </router-link>

        <TooliabaButton @click="updateListing">Save & Leave</TooliabaButton>
    </div>
    </PopupShell>    
</template>

<script>
import PopupShell from '@/components/editListing/popups/PopupShell.vue';
import GreyButton from '@/components/buttons/GreyButton.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        PopupShell,
        GreyButton,
        BlackButton,
        TooliabaButton
    },
    methods: {
        updateListing() {
            this.$router.push({ path: '/active-listings' });
        }
    }
};
</script>
